import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AuthClientConfig } from '@auth0/auth0-angular';
import { ApiService } from 'src/app/api.service';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { RouterLink } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, RouterLink, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, DatePipe]
})
export class MessagesComponent implements OnInit {
  hasApiError = false;
  apiError: string;
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = [
    'creation_date',
    'from_user_name',
    'from_org_name',
    'body',
    'actions'];

  constructor(
    private api: ApiService,
    private configFactory: AuthClientConfig
  ) { }

  ngOnInit(): void {
    this.getMessages()
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;

  getMessages() {
    this.api.getMessages$().subscribe({
      next: (res) => {
        this.hasApiError = false;
        this.dataSource = new MatTableDataSource<any>(res);
        this.dataSource.paginator = this.paginator;
      },
      error: (error) => {
        this.hasApiError = true;
        this.apiError = error.message;
      },
    });
  }

  deleteMessage(id: string) {
    this.api.deleteMessagesId$(id).subscribe({
      next: () => {
        this.hasApiError = false;
        this.getMessages()
      },
      error: (error) => {
        this.hasApiError = true;
        this.apiError = error.message;
      },
    });
  }
}
